import { BackgroundComponent } from "~/src/components/background";
import { singleton } from "tsyringe";
import { PreludeComponent } from "~/src/components/prelude";
import { PaintingsSliderComponent } from "../components/paintings-slider";
import { PreloaderComponent } from "../components/preloader";

@singleton()
export class MainOrchestrator {
  constructor(
    private background: BackgroundComponent,
    private prelude: PreludeComponent,
    private paintingsSlider: PaintingsSliderComponent,
    private preloader: PreloaderComponent
  ) {}
  async start() {
    await this.preloader.hide();
    document.body.classList.remove("loading");
    this.background.mount();
    this.prelude.mount();
    await this.prelude.play();
    await this.background.showInitialLight();
    this.background.startInteraction();
    this.paintingsSlider.mount();
    await this.paintingsSlider.playEnterAnimation();
  }
}
